import { Component, computed, inject, Signal, signal, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FileCandidate, FilePickerData, filterFileCandidates } from '../bu-pdf-bulk-upload-review';

/** Lets the user choose one existing file for a row. The look and the search follow the row picker, so both pickers feel the same. */
@Component({
  selector: 'app-bu-pdf-file-picker-dialog',
  templateUrl: './bu-pdf-file-picker-dialog.component.html',
  styleUrls: ['../bu-pdf-row-picker-dialog/bu-pdf-row-picker-dialog.component.scss'],
  standalone: false,
})
export class BuPdfFilePickerDialogComponent {
  private readonly dialogRef: MatDialogRef<BuPdfFilePickerDialogComponent, FileCandidate> = inject(MatDialogRef);
  readonly data: FilePickerData = inject<FilePickerData>(MAT_DIALOG_DATA);

  readonly search: WritableSignal<string> = signal<string>('');
  readonly selectedKey: WritableSignal<string> = signal<string>('');
  readonly shown: Signal<FileCandidate[]> = computed(() => filterFileCandidates(this.data.candidates, this.search()));

  onSearch(event: Event): void {
    this.search.set((event.target as HTMLInputElement).value);
  }

  select(candidate: FileCandidate): void {
    this.selectedKey.set(candidate.key);
  }

  associate(): void {
    const chosen: FileCandidate | undefined = this.data.candidates.find((candidate: FileCandidate) => candidate.key === this.selectedKey());
    this.dialogRef.close(chosen);
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }
}
